import { useEffect, useState } from "react";
import buildVersion from "../buildVersion.json";

// The version this bundle was built as (see scripts/write-version.js).
export const CURRENT_VERSION = buildVersion.version;

export const VERSION_POLL_INTERVAL_MS = 5 * 60_000;

// True once a newer deploy is live than the one this tab is running. Checks
// public/version.json every few minutes and whenever the tab comes back into
// view. Never reloads by itself — the user decides (UpdateBanner), so a
// half-filled form is never lost. Any fetch error just means "no news".
export function useNewVersionAvailable() {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (CURRENT_VERSION === "dev" || available) return;

    let cancelled = false;

    async function check() {
      try {
        const res = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled && data?.version && data.version !== CURRENT_VERSION) {
          setAvailable(true);
        }
      } catch {
        // Offline or a deploy mid-flight — try again on the next tick.
      }
    }

    function onVisible() {
      if (document.visibilityState === "visible") check();
    }

    check();
    const id = setInterval(check, VERSION_POLL_INTERVAL_MS);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [available]);

  return available;
}
